// Created by hejikun on 2018/7/30 0002.
let insurance = [
  {
    path: '/insurance',
    name: '保险服务',
    component: () => import('@/pages/insurance')
  },
  {
    path: '/insurance_services',
    name: '保险服务',
  component: () => import('@/pages/insurance/insurance_services')
  },
  {
    path: '/insurance_services_v3',
    name: '保险服务',
    component: () => import('@/pages/insurance/insurance_services_v3')
  },
  {
    path: '/insurance_services_v3_qr',
    name: '保险服务',
    component: () => import('@/pages/insurance/insurance_services_v3_qr')
  },
  {
    path: '/insuraervice',
    name: '保险服务',
    component: () => import('@/pages/insurance/insurance_service')
  },
  {
    path: '/insurance_plans',
    name: '保障计划',
    component: () => import('@/pages/insurance/insurance_plans')
  },
  // {
  //   path: '/insurance_form',
  //   name: '保险服务',
  //   component: () => import('@/pages/insurance/insurance_form')
  // },
  {
    path: '/insurance_payback_sync',
    name: '支付',
    component: () => import('@/pages/insurance/insurance_payback_sync')
  },
  {
    path: '/insurance_payback_async',
    name: '支付',
    component: () => import('@/pages/insurance/insurance_payback_async')
  },
  {
    path: '/insurance_center',
    name: '保险中心',
    component: () => import('@/pages/insurance/insurance_center')
  },
  {
    path: '/insurance_pdf',
    name: '电子保单',
    component: () => import('@/pages/insurance/insurance_pdf')
  },
  {
    path: '/insurance_order',
    name: '保单明细',
    component: () => import('@/pages/insurance/insurance_order')
  },
  {
    path: '/insurance_list',
    name: '保险列表',
    component: () => import('@/pages/insurance/insurance_list')
  },
  {
    path: '/insurance_prefecture',
    name: '新冠保险专区',
    component: () => import('@/pages/insurance/insurance_prefecture')
  },
  {
    path: '/insurance_huimin',
    name: '2022年度“春城惠民保”',
    component: () => import('@/pages/insurance/insurance_huimin')
  }
]

export default insurance
